module.exports = __webpack_public_path__ + "public/img/invite.d576c61a.png";